import React from "react";
import { Checkbox } from "primereact/checkbox";

const CheckboxComponent = ({ onChange, checked }) => (
    <Checkbox onChange={onChange} checked={checked} />
  );

  export default CheckboxComponent;